import { getRequest, HandlerResponse, postRequest } from "./api";
import { ObjToQueryString } from "../utility-functions/UtilityFns";
import { API_URL } from "./Environment";

export const getFAQsAPI = async (_queryParams) => {
  const queryString = ObjToQueryString(_queryParams);
  return getRequest(`${API_URL}chat/faq-lists${queryString}`).then((resp) =>
    HandlerResponse(resp),
  );
};
console.log(API_URL)
export const selectFaqAPI = async (payload) => {
  return postRequest(`${API_URL}chat/faqs-access-log`,payload).then((resp) =>
    HandlerResponse(resp),
  );
};
